import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar/Navbar";
import "aos/dist/aos.css";
import Service from "./pages/service";
import Services from "./pages/Services";
import Story from "./pages/ourStory";
import Contact from "./pages/Contact";
import Review from "./pages/Review";
import Reviews from "./pages/Reviews";
import React, { useState } from "react";
import TermsAndConditions from "./pages/TermsAndConditions";
import { Toaster } from "react-hot-toast";

function App() {
  const [state, setState] = useState(0);

  const QuoteService = () => {
    setState(1);
  };

  return (
    <>
      <Toaster position="top-center" />
      <Router>
        <Navbar QuoteService={QuoteService} />
        <Routes>
          {/* Define each route properly */}
          <Route path="/" element={<Home state={state} />} />
          <Route path="/service" element={<Service />} />
          <Route path="/ourStory" element={<Story />} />
          <Route path="/service/:name" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/submit-review/:id" element={<Review />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
